import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { Subject, BehaviorSubject } from "rxjs";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const closeModals = new Subject();
export const openLoginModal = new Subject();
export const closeLoginModal = new Subject();
export const openHelpModal = new Subject();
export const closeHelpModal = new Subject();
export const openDeleteModal = new Subject();
export const closeDeleteModal = new Subject();
export const resetPagination = new Subject();
export const openFeedbackForm = new Subject();
export const closeFeedbackForm = new Subject();
export const openOnboardingModal = new Subject();
export const closeOnboardingModal = new Subject();
export const openPricingModal = new Subject();
export const closePricingModal = new Subject();
export const openDownloadLimitModal = new Subject();
export const closeDownloadLimitModal = new Subject();
export const openTopupModal = new Subject();
export const closeTopupModal = new Subject();
export const openCreditModal = new Subject();
export const closeCreditModal = new Subject();
export const openPricingDrawer = new Subject();
export const closePricingDrawer = new Subject();
export const openPhotoshootModal = new Subject();
export const closePhotoshootModal = new Subject();
export const invokeDownloadStatusAPI = new Subject();
export const openGenerationSidebar = new Subject();
export const closeGenerationSidebar = new Subject();
export const openAIVideoModal = new Subject();
export const closeAIVideoModal = new Subject();
export const startSkeletonLoader = new Subject();
export const stopSkeletonLoader = new Subject();
export const openVideoMockupLimitModal = new Subject();
export const startVideoGenerationLoader = new Subject();
export const openDownloadConfirmationModal = new Subject();
export const openDesignUploaderModal = new Subject();
export const openNavigationDrawer = new Subject();
export const openFilterDrawer = new Subject();
export const openPreviewDrawer = new Subject();
export const openPlanFeaturesDrawer = new Subject();
export const openEditorModal = new Subject();
export const closeEditorModal = new Subject();
export const saveVideoMockupConfig = new Subject();
export const openSearchModal = new Subject();
export const openVideoModal = new Subject();
export const openAIToolsDrawer = new Subject();
export const closeAIToolsDrawer = new Subject();

export const editorUpgradeDialog$ = new BehaviorSubject("closed");
export const openEditorUpgradeModal = () => editorUpgradeDialog$.next("open");
export const closeEditorUpgradeModal = () =>
  editorUpgradeDialog$.next("closed");
